import React from "react";
import { Box, Alert, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

export const SuccessStep = () => {
  return (
    <Box>
      <Alert severity="success" sx={{ mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          <FormattedMessage id="general.thank-you" defaultMessage="Vielen Dank!" />
        </Typography>
        <Typography variant="body2">
          <FormattedMessage id="general.thank-you-description" defaultMessage="Dass du uns dein Anliegen mitgeteilt hast. Du wirst in Kürze eine Bestätigungsmail erhalten." />
        </Typography>
        <Typography variant="body2">
          <FormattedMessage id="general.staff-will-handle" defaultMessage="Unsere Mitarbeiter werden so schnell wie möglich das angegebene Problem bearbeiten." />
        </Typography>
      </Alert>
    </Box>
  );
};
